import { render } from "./product_detail.vue?vue&type=template&id=154804ce"
import script from "./product_detail.vue?vue&type=script&lang=js"
export * from "./product_detail.vue?vue&type=script&lang=js"

import "./product_detail.vue?vue&type=style&index=0&id=154804ce&lang=css"
script.render = render

export default script